<template>
  <v-container
    fluid
  >
    <!-- Graph -->
    <v-subheader>Índice de temperatura e umidade</v-subheader>
    <v-row class="ma-0">
      <v-col
        cols="12"
      >
        <apexcharts
          type="line"
          :height="400"
          :options="chartOptions"
          :series="series"
        />
      </v-col>
    </v-row>
    
    <!-- Table -->
    <v-row class="ma-0">
      <v-col
        cols="12"
      >
        <v-data-table
          dense
          :headers="tableHeaders"
          disable-sort
          no-results-text="Nenhum registro encontrado"
          :items="filteredProbeDataDesc"
          color="secondary"
          loading-text="Carregando registros...aguarde"
        >
          <template v-slot:item.tsProbeRegistry="{ item }">
            <span class="caption">{{ item["tsProbeRegistry"] | dateFormateDisplay}}</span>
          </template>
          <template v-slot:item.tsProbeRegistry="{ item }">
            <span class="caption">{{ item["tsProbeRegistry"] | dateFormateDisplay }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apexcharts from "vue-apexcharts"
import {includes} from "lodash/collection"
import moment from "moment"

export default {
  name: "AmbienceItuGraph",
  components: {
    apexcharts
  },
  props: {
    probeData: {
      type: Array,
      required: true
    }
  },
  filters: {
    dateFormateDisplay(value) {
      const parsedDate = moment(value)
      if (!parsedDate.isValid()) return ""
      return parsedDate.format("HH:mm - DD/MM/Y")
    }
  },
  computed: {
    filteredProbeData() {
      return this.probeData.filter((item) => {
        return (includes(["ITU"], item["strAmbienceName"]))
      }).sort((a, b) => new Date(a["tsProbeRegistry"]) - new Date(b["tsProbeRegistry"]))
    },
    filteredProbeDataDesc() {
      return this.probeData.filter((item) => {
        return (includes(["ITU"], item["strAmbienceName"]))
      }).sort((a, b) => new Date(b["tsProbeRegistry"]) - new Date(a["tsProbeRegistry"]))
    },
    
    ituMinSeries() {
      return this.filteredProbeData.map(item => item["flProbeMin"])
    },
    ituMaxSeries() {
      return this.filteredProbeData.map(item => item["flProbeMax"])
    },
    ituAvgSeries() {
      return this.filteredProbeData.map(item => item["flProbeAvg"])
    },
    series() {
      return [
        {
          name: "Índice Mínimo",
          type: "line",
          data: this.ituMinSeries
        },
        {
          name: "Índice Máximo",
          type: "line",
          data: this.ituMaxSeries
        },
        {
          name: "Índice Temperatura Umidade",
          type: "line",
          data: this.ituAvgSeries
        },
      ]
    },
    
    categories() {
      const dateList = this.filteredProbeData.map(item => item["tsProbeRegistry"])
      return dateList.sort((a, b) => new Date(a) - new Date(b))
    },
    chartOptions() {
      const colors = ["#10303D", "#9575CD", "#FF5429"]
      const stroke = {
        curve: "straight",
        dashArray: [5, 5, 0],
        width: [4, 4, 2],
        colors: ["#10303D", "#9575CD", "#FF5429"]
      }
      const markers = {
        size: [1, 1, 6]
      }
      const xaxis = {
        type: "datetime",
        categories: this.categories,
        title: {
          text: "Data/Hora da Medição",
          offsetY: 10
        },
        labels: {
          style: {
            colors: "#000000de"
          },
        }
      }
      const yaxis = {
        labels: {
          style: {
            color: "#000000de"
          },
          formatter: function (value) {
            return value + " %"
          }
        }
      }
      const legend = {
        position: "top",
        horizontalAlign: "center",
        fontSize: "14px",
        labels: {
          useSeriesColors: false
        }
      }
      const toolbar = {
        show: true,
        tools: {
          download: true,
          selection: true
        }
      }
      return {
        colors: colors,
        stroke: stroke,
        markers: markers,
        xaxis: xaxis,
        yaxis: yaxis,
        legend: legend,
        toolbar: toolbar,
      }
    },
     tableHeaders() {
      return [
        {text: "Data", value: "tsProbeRegistry", sortable: false},
        {text: "Índice Mínimo", value: "flProbeMin", sortable: false},
        {text: "Índice Máximo", value: "flProbeMax", sortable: false},
        {text: "Índice Temperatura Umidade", value: "flProbeAvg", sortable: false},
      ]
    }
  },
}
</script>

<style scoped>

</style>